
export class AudioHandler {
    private screenStream: MediaStream | null = null;
    private mediaStream: MediaStream | null = null;
    private mediaRecorder: MediaRecorder | null = null;

    async setAudioScreenInput(
        getStream: () => Promise<MediaStream>,
        onChunk: (buffer: ArrayBuffer) => void,
    ) {
        this.screenStream = await getStream();

        const audioContext = new AudioContext();
        const destination = audioContext.createMediaStreamDestination();
        audioContext.createMediaStreamSource(this.screenStream).connect(destination);

        await this.setAudioInput(async () => destination.stream, onChunk);
    }

    async setAudioInput(
        getStream: () => Promise<MediaStream>,
        onChunk: (buffer: ArrayBuffer) => void,
    ) {
        try {
            console.info("[AudioHandler] Setting audio input...");
            this.mediaStream = await getStream();
            const [track] = this.mediaStream.getAudioTracks();
            const settings = track.getSettings();
            console.log("[AudioHandler] Track settings:", settings);

            const supportedMimeTypes = [
                // 'audio/ogg;codecs=opus', // for uploading a file
                'audio/webm;codecs=opus',
                'audio/webm',
            ].filter(t => MediaRecorder.isTypeSupported(t));

            console.log('[AudioHandler] Supported MIME types:', supportedMimeTypes);

            const recorderOptions: MediaRecorderOptions = {
                audioBitsPerSecond: 128_000,
                ...(supportedMimeTypes.length > 0 && {
                    mimeType: supportedMimeTypes[0]
                })
            };

            this.mediaRecorder = new MediaRecorder(this.mediaStream, recorderOptions);

            this.mediaRecorder.ondataavailable = async (event) => {
                try {
                    const buffer = await event.data.arrayBuffer();
                    onChunk(buffer);
                } catch (err) {
                    console.error("[AudioHandler] MediaRecorder ondataavailable error:", err);
                }
            };

            this.mediaRecorder.start(250);
        } catch (error) {
            console.error("[AudioHandler] Failed to set audio input:", error);
            throw error;
        }
    }

    stop() {
        console.info("[AudioHandler] Stopping audio input...");
        this.mediaRecorder?.stop();

        this.mediaStream?.getTracks().forEach((track) => track.stop());
        this.screenStream?.getTracks().forEach((track) => track.stop());

        this.mediaRecorder = null;
        this.mediaStream = null;
        this.screenStream = null;
    }
}
